import h from 'virtual-dom/h';
import { customFetch as fetch } from '../fetch';

export enum NoShowAssessment {
    Pending = 0,
    Excused = 1,
    Unexcused = 2,
}

export const noShowAssessmentLabels: Record<NoShowAssessment, string> = {
    [NoShowAssessment.Pending]: 'In afwachting',
    [NoShowAssessment.Excused]: 'Geoorloofd',
    [NoShowAssessment.Unexcused]: 'Ongeoorloofd',
};

/**
 * Listview row action that sets the assessment of a no-show clock (`item.id` is the clock id).
 * Hidden when the no-show already has this assessment, or when `show` returns false.
 */
export const assessNoShowAction = (
    assessment: NoShowAssessment,
    iconClass: string,
    position: number,
    onAssessed: () => void,
    show: (item: any) => boolean = () => true,
) => ({
    name: `assess-no-show-${assessment}`,
    position,
    type: 'confirm-popup' as const,
    show: (item: any) => show(item) && item.noShowAssessment !== assessment,
    render: () =>
        h(
            'a',
            {
                href: '#',
                title: `No-show: ${noShowAssessmentLabels[assessment]}`,
            },
            [h('i', { className: `fa ${iconClass}` }, [])],
        ),
    confirmText: `Weet u zeker dat u deze no-show op "${noShowAssessmentLabels[assessment].toLowerCase()}" wilt zetten?`,
    onConfirm: async (item: any) => {
        const response = await fetch(
            `/Admin/Clocks/AssessNoShow/${item.id}?assessment=${assessment}`,
            { method: 'POST' },
        );
        if (response.ok) {
            onAssessed();
        }
    },
});
